import { supabase } from "@/integrations/supabase/client";

export async function enrichSpecificBook(bookId: string) {
  try {  
    console.log(`[EnrichmentUtils] Triggering enrichment for book ${bookId}`);
    
    const { data, error } = await supabase.functions.invoke('enrich-books', {
      body: {
        action: 'enrich-books',
        bookIds: [bookId],
        batchSize: 1
      }
    });

    if (error) {
      throw error;
    }

    console.log(`[EnrichmentUtils] Enrichment completed for book ${bookId}:`, data);
    return data;
  } catch (error) {
    console.error(`[EnrichmentUtils] Error enriching book ${bookId}:`, error);
    throw error;
  }
}